<template>
  <div>
    <naj-box :title="local.home.tabs.petitionDecisionsJudgements">
      <v-row class="mt-7">
        <v-col cols="12">
          <naj-item-table
            :data-items="paginatedData"
            :headers="headers"
            :loading="loading"
            :items-per-page="20"
            :server-items-length="totalItems"
            :pagination="{ pageSize: 20}"
            @update:page="onPageChange"
          >
            <template slot="actions" slot-scope="{ item }">
              <naj-button outlined small @click="viewItem(item)">
                {{ local.common.show }}
              </naj-button>
            </template>
          </naj-item-table>
        </v-col>
      </v-row>
    </naj-box>

    <!-- Decision/Judgement PDF Modal -->
    <naj-modal
      ref="pdfModal"
      :width="1500"
      :footer="true"
      :close-button="true"
      :show-footer-close-button="true"
      :title="modalTitle"
      @onClose="closeModal"
    >
      <div class="preview-holder">
        <div v-if="loading" class="loader-holder">
          <naj-loader></naj-loader>
        </div>
        <template v-else>
          <div v-if="document" class="attachment-file-viewer pdf-file">
            <div class="pdf-container">
              <div class="pdf-wrapper">
                <div class="pdf-holder">
                  <embed :src="fileUrl" />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="document-text">
            <h1>{{ local.common.noData }}</h1>
          </div>
        </template>
      </div>

      <!-- <template slot="actions">
        <naj-button outlined color="primary" @click="printSelectedDocument">
          {{ printButtonLabel }}
        </naj-button>
      </template> -->
    </naj-modal>
  </div>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
import { toHijriDate } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'PetitionDecisionsJudgements',
  data() {
    return {
      loading: false,
      selectedDocument: {},
      document: null,
      data: [],
      paginatedData: [],
    };
  },
  computed: {
    totalItems() {
      return this.data.length;
    },
    modalTitle() {
      if (!this.selectedDocument.type) return '';
      return this.selectedDocument.type === 'decision' ? this.local.home.tabs.decisions : this.local.home.tabs.judgements;
    },
    printButtonLabel() {
      if (!this.selectedDocument.type) return this.local.common.print;
      return this.selectedDocument.type === 'decision' ? 'طباعة القرار' : 'طباعة الحكم';
    },
    fileUrl() {
      return getBlobUrl(this.document, false);
    },
    headers() {
      return [
        {
          value: 'caseSourceId',
          text: this.local.common.type,
          formatter: (value) => (value === 3 ? this.local.home.tabs.decision : this.local.home.tabs.judgement),
        },
        {
          value: 'code',
          text: this.local.common.code,
        },
        {
          value: 'courtName',
          text: this.local.home.tabCommon.courtName,
        },
        {
          value: 'creationDate',
          text: this.local.common.date,
          formatter: toHijriDate,
        },
        {
          value: 'actions',
          text: this.local.home.tabCommon.settings,
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ];
    },
  },
  mounted() {
    // initialize objectKey from route
    if (this.$route.params.objectKey) {
      this.loadData(this.$route.params.objectKey);
    }
  },
  methods: {
    ...mapCasesActions(['getAppealRequestJudgementJudgementsAndDecisions', 'getTrustedSourceAttachment']),
    loadData(appealRequestJudgementObjectKey) {
      this.loading = true;
      this.getAppealRequestJudgementJudgementsAndDecisions(appealRequestJudgementObjectKey)
        .then((response) => {
          this.data = response.data || [];
          this.paginatedData = this.data.slice(0, 20); // initial pagination, showing first 10 items
        })
        .catch(() => {
          // handle error silently or show user notification
          this.data = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPageChange(pageNumber) {
      const itemsPerPage = 20;
      const start = (pageNumber - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      this.paginatedData = this.data.slice(start, end);
    },
    viewItem(item) {
      this.selectedDocument = { ...item };
      this.$refs.pdfModal.show();
      this.getDocument();
    },
    getDocument() {
      if (!this.selectedDocument.spid) {
        this.document = null;
        return;
      }
      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedDocument.spid)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.resetData();
    },
    resetData() {
      this.document = null;
      this.loading = false;
      this.selectedDocument = {};
    },
    printSelectedDocument() {
      if (this.document) {
        const link = document.createElement('a');
        link.href = this.fileUrl;
        link.download = `${this.selectedDocument.code || 'document'}.pdf`;
        link.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-holder {
  .loader-holder {
    display: flex;
    justify-content: center;
    padding: 40px;
  }

  .attachment-file-viewer.pdf-file {
    .pdf-container {
      .pdf-wrapper {
        .pdf-holder {
          embed {
            width: 100%;
            height: 600px;
            border: none;
          }
        }
      }
    }
  }

  .document-text {
    text-align: center;
    padding: 40px;

    h1 {
      color: #666;
    }
  }
}
</style>
